export const STAR_SIZE = 25;
